<template>
    <div class="mainpage">
        <template v-if="selectBaseInfo">
            <div class="whitebox">
                <h1>Discover the true self on the inside</h1>
                <h3>Please tell us a little about yourself</h3>
                <ul>
                    <li><select v-model="gender">
                        <option selected="selected" value="">My Gender</option>
                        <option v-for="(i, index) in genderList" :value="i" :key="index">{{i}}</option>
                    </select></li>
                    <li><select v-model="age">
                        <option selected="selected" value="">My Age</option>
                        <option v-for="(i, index) in ageList" :value="i" :key="index">{{i}}</option>
                    </select></li>
                    <li v-if="errorMsg" class="wrong_tips">{{errorMsg}}</li>
                    <li>
                        <button @click="toSelect">Next</button>
                    </li>
                </ul>
            </div><!--whitebox end--->
        </template>
        <template v-else>
            <div class="whitebox test">
                <h1>{{title}}</h1>
                <h3>Total quiz progress: <span>{{progress}}%</span></h3>
                <div class="testbox">
                    <ol>
                        <li v-for="(i, index) in itemList" v-show="index>=pageStart && index<pageStart+5" :key="index"
                            :id="'item-'+index">
                            <h2>{{i.content}}</h2>
                            <div class="answer">
                                    <span v-for="(ii, index2) in i.degreeList"
                                          @click="select(index, ii, index2)"
                                          :class="{'done': itemColor[index] && itemColor[index][index2]}"
                                          :style="{'background-color': itemColor[index] && itemColor[index][index2]}"
                                          :key="index2"
                                    >{{ii.showValue}}</span>
                            </div>
                        </li>
                        <li v-if="errorMsg2&&!finalPage" class="wrong_tips">{{errorMsg2}}</li>
                    </ol>
                    <button v-if="!finalPage" @click="nextPage">Next</button>
                    <button v-else @click="submit">Next</button>
                    <div class="adbanner">
                        <!-- <a href="https://www.kinkdapp.com/app.html" target="_blank">
                        <img src="/images/banner.png" width="540" height="300" alt=""/></a> -->
                        <a href="https://www.kinkdapp.com/download.html" target="_blank">
                        <img src="/images/banner-month.png" width="540" height="300" alt=""/></a>
                    </div>
                </div>
            </div><!--whitebox end--->
        </template>
    </div><!--mainpage end--->
</template>
<script>
    import util from '../util';
    import config from '../config';

    export default {
        name: "test",
        data() {
            return {
                selectBaseInfo: true,   //select gender or age.
                genderList: [],
                gender: '',
                ageList: [],
                age: '',
                title: '',
                itemList: [],
                item: [],
                itemColor: [],   //二维数组
                pageStart: 0,   //当前页数开始的index
                errorMsg: '',
                errorMsg2: '',
            }
        },
        computed: {
            done() {
                let len = 0;
                for(let i =0;i<this.item.length;i++){
                    if (this.item[i] !== undefined && this.item[i] !== null) ++len;
                }
                return len;
            },
            progress() {
                let len = this.itemList.length;
                let res = Math.round(this.done * 100 / len);
                return res;
            },
            //是否为最后一页
            finalPage() {
                return this.pageStart >= this.itemList.length - 5;
            }
        },
        watch: {
            progress(v) {
                if (v === 100) {
                    this.errorMsg2 = ''
                }
            }
        },
        methods: {
            getData() {
                util.axios.post(config.test_url)
                    .then((data) => {
                        if (data) {
                            this.genderList = data.genderList;
                            this.ageList = data.ageList;
                            this.title = data.title;
                            this.itemList = data.itemList;
                        }
                    })
            },
            toSelect() {
                if (this.gender && this.age) {
                    this.selectBaseInfo = false;
                } else {
                    this.errorMsg = 'Please select an option'
                }
            },
            select(index, item, index2) {
                this.$set(this.item, index+'', item.percentage);
                let color = [];
                color[index2] = item.color;
                this.$set(this.itemColor, index, color);
            },
            nextPage() {
                let newPageStart = this.pageStart + 5;
                this.errorMsg2 = '';
                if (this.done === newPageStart) {
                    this.pageStart = newPageStart;
                    this.$nextTick().then(() => this.toTop());
                } else {
                    this.toRemain();
                }
            },
            submit() {
                if (this.progress === 100) {
                    this.$store.commit('addVerifyCallback', this.submit)
                    util.axios.post(config.test_submit_url, {
                        gender: this.gender,
                        age: this.age,
                        testData: this.item
                    }).then((data, msg) => {
                        if (data) {
                            this.toNext(data.id);
                        } else {
                            this.errorMsg2 = msg;
                        }
                    })
                } else {
                    this.toRemain()
                }
            },
            //跳转到最上方
            toTop() {
                let firstItem = this.$el.querySelector(".whitebox.test");
                if (firstItem)
                    firstItem.scrollIntoView({behavior: "smooth", inline: "start"});
            },
            //跳转到未选择的项目
            toRemain() {
                this.errorMsg2 = 'Please answer all questions on this page';
                setTimeout(() => {
                    let index = 0;
                    for (let i in this.itemList) {
                        if (this.item[i] === undefined) {
                            index = i;
                            break;
                        }
                    }
                    let dom = this.$el.querySelector(`#item-${index}`);
                    dom.scrollIntoView({
                        behavior: "smooth"
                    });
                }, 500);
            },
            toNext(id) {
                this.$router.push({path: `/result/${id}`});
            }
        },
        mounted() {
            this.getData();
        }

    }
</script>

<style scoped>
    .done {
        color: #fff !important;
    }
</style>
